// Application Constants
export const APP_CONFIG = {
  NAME: 'Swirl',
  VERSION: '1.0.0',
  DESCRIPTION: 'AI-powered content analysis platform',
  DEFAULT_MODEL: 'gpt-4o',
  FALLBACK_MODEL: 'gpt-3.5-turbo',
  MAX_TOKENS: 2000,
  DEFAULT_TEMPERATURE: 0.7,
  MAX_FILE_SIZE: 25 * 1024 * 1024, // 25MB
  SUPPORTED_AUDIO_FORMATS: ['mp3', 'mp4', 'mpeg', 'mpga', 'm4a', 'wav', 'webm', 'flac', 'ogg'],
  SUPPORTED_VIDEO_FORMATS: ['mp4', 'webm', 'mov', 'avi'],
  SUPPORTED_IMAGE_FORMATS: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'],
  SUPPORTED_TEXT_FORMATS: ['txt', 'md', 'json', 'csv'],
};

// API Endpoints
export const API_ENDPOINTS = {
  SUPABASE: {
    AUTH: 'auth',
    CONTENT: 'instagram_content',
    TOPICS: 'topics',
    MESSAGES: 'chat_messages',
    WEBHOOK_LOGS: 'webhook_logs',
  },
  OPENAI: {
    CHAT: 'chat/completions',
    AUDIO: 'audio/transcriptions',
    IMAGES: 'images/analyze',
  },
};

// UI Constants
export const UI_CONFIG = {
  ANIMATION_DURATION: 200,
  DEBOUNCE_DELAY: 300,
  TOAST_DURATION: 3000,
  MODAL_Z_INDEX: 50,
  DROPDOWN_Z_INDEX: 100,
  MAX_CONTENT_LENGTH: 10000,
  PAGINATION_LIMIT: 20,
  SEARCH_DEBOUNCE: 500,
};

// Color Palette
export const COLORS = {
  PRIMARY: '#3B82F6',
  SECONDARY: '#8B5CF6',
  SUCCESS: '#10B981',
  WARNING: '#F59E0B',
  ERROR: '#EF4444',
  INFO: '#06B6D4',
  GRAY: '#6B7280',
  TOPIC_COLORS: [
    '#3B82F6', '#10B981', '#F59E0B', '#EF4444',
    '#8B5CF6', '#F97316', '#06B6D4', '#EC4899',
    '#84CC16', '#14B8A6'
  ],
};

// Content Types
export const CONTENT_TYPES = {
  POST: 'post',
  REEL: 'reel',
  STORY: 'story',
  VIDEO: 'video',
  TEXT: 'text',
  URL: 'url',
};

// Analysis Status
export const ANALYSIS_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  TRANSCRIBING: 'transcribing',
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  API_KEY_MISSING: 'API key not configured. Please check your environment variables.',
  SUPABASE_ERROR: 'Database connection failed. Please try again.',
  OPENAI_ERROR: 'AI service unavailable. Please try again later.',
  FILE_TOO_LARGE: 'File too large. Maximum size is 25MB.',
  INVALID_FILE_TYPE: 'Invalid file type. Please select a supported format.',
  GENERIC_ERROR: 'An unexpected error occurred. Please try again.',
};

// Success Messages
export const SUCCESS_MESSAGES = {
  CONTENT_ADDED: 'Content added successfully!',
  TOPIC_CREATED: 'Topic created successfully!',
  ANALYSIS_COMPLETE: 'Analysis completed!',
  DOWNLOAD_COMPLETE: 'Download completed!',
  SETTINGS_SAVED: 'Settings saved successfully!',
};

// Default Values
export const DEFAULTS = {
  TOPIC_NAME: 'Misc',
  TOPIC_DESCRIPTION: 'Files that couldn\'t be automatically categorized',
  CONTENT_TITLE: 'Content',
  USER_AVATAR: 'U',
  LOADING_TEXT: 'Loading...',
  NO_CONTENT_TEXT: 'No content available',
  SEARCH_PLACEHOLDER: 'Search...',
};

// Regex Patterns
export const REGEX_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  URL: /^https?:\/\/.+/,
  INSTAGRAM_URL: /instagram\.com\/(p|reel|stories)\/[^\/]+/,
  YOUTUBE_URL: /(youtube\.com\/watch\?v=|youtu\.be\/)[^\/]+/,
  TIKTOK_URL: /tiktok\.com\/@[^\/]+\/video\/[^\/]+/,
  HEX_COLOR: /^#[0-9A-Fa-f]{6}$/,
};

// Storage Keys
export const STORAGE_KEYS = {
  USER_PREFERENCES: 'swirl_user_preferences',
  RECENT_TOPICS: 'swirl_recent_topics',
  THEME: 'swirl_theme',
  LANGUAGE: 'swirl_language',
  NOTIFICATIONS: 'swirl_notifications',
};

// Feature Flags
export const FEATURES = {
  ENABLE_ANALYTICS: true,
  ENABLE_NOTIFICATIONS: true,
  ENABLE_DARK_MODE: true,
  ENABLE_OFFLINE_MODE: false,
  ENABLE_BATCH_UPLOAD: true,
  ENABLE_AI_CATEGORIZATION: true,
  ENABLE_VIDEO_TRANSCRIPTION: true,
  ENABLE_DOWNLOAD_EXPORT: true,
};
